import axios from "axios";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../node_modules/react-modal/dist/react-modal";

axios.defaults.withCredentials = true;

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(<App />);
